module.exports = __webpack_public_path__ + "static/media/fuelops.637aa2de.svg";